/// <reference path="index.d.ts"/>

import "./style.scss";
import * as React from "react";
import { withRouter } from "react-router-dom";

import ReportForm from "../ReportForm";

class CreateReport extends React.Component<
  ICreateReportProps & ICreateReportActions,
  {}
> {
  componentWillMount() {
    let { merchant_id, report_id } = this.props.match.params;
    this.props.flushReport();
    this.props.getSchema();
    this.props.createReport(merchant_id);
  }

  render() {
    return (
      <div className="create-report">
        <ReportForm
          type="Create"
          submit={this.props.submitForm}
          {...this.props}
        />
      </div>
    );
  }
}

export default withRouter(CreateReport as any);



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/CreateReport/component.tsx